//Custom states
export const registerStates = (states) => {

    states.customState = (state = {}, action) => {
        switch (action.type) {
            case 'GENERAL_LOADED':
                return {
                    ...state,
                    footer: action.footer
                };
            case 'CUSTOM_DATA_KWH':
                return {
                    ...state,
                    kwh_data: action.data
                };
            case 'MENU_CURRENT':
                return {
                    ...state,
                    menu_toggled: false,
                    usermenu_toggled: false,
                    search_toggled: false,
                    submenu_id: -1,
                    subchildmenu_id: null,
                };
            case 'MENU_TOGGLED':
                return {
                    ...state,
                    menu_toggled: !state.menu_toggled,
                    usermenu_toggled: false,
                }
            case 'SUBMENU_TOGGLED':
                return {
                    ...state,
                    submenu_toggled: (action.id > -1),
                    submenu_id: action.id,
                    subchildmenu_id: null,
                    usermenu_toggled: false,
                    search_toggled: false
                }
            case 'SUBCHILDMENU_TOGGLED':

                let nav_ids = [];

                if (state.subchildmenu_id) {
                    nav_ids = state.subchildmenu_id;
                }

                if (nav_ids.indexOf(action.id) >= 0) {
                    nav_ids = nav_ids.filter((item) => item !== action.id)
                } else {
                    nav_ids = nav_ids.concat(action.id)
                }

                return {...state,subchildmenu_id: nav_ids,}
            case 'USERMENU_TOGGLED':
                return {
                    ...state,
                    usermenu_toggled: !state.usermenu_toggled,
                    submenu_id: -1,
                    menu_toggled: false,
                    search_toggled: false,
                }
            case 'SEARCH_TOGGLED':
                return {
                    ...state,
                    search_toggled: !state.search_toggled,
                    submenu_toggled: (action.id > -1),
                    submenu_id: action.id,
                    usermenu_toggled: false,
                }
            case 'PAGE_SCROLLED':
                return {
                    ...state,
                    scrolled: action.scrolled
                }
            case 'HIDE_BACKDROP':
                return {
                    ...state,
                    search_toggled: false,
                    usermenu_toggled: false,
                    submenu_id: -1,
                }
            case 'SET_MODAL':
                return {
                    ...state,
                    modal_content: action.modal_content,
                }
            default:
                return state;
        }
    }

    states.newsState = (state = {}, action) => {
        switch (action.type) {
            case 'NEWS_LOADED':
                return {
                    ...state,
                    news: state.news ? state.news.concat(action.news) : action.news,
                    page: action.page,
                    news_loaded: true
                };
            case 'LOAD_MORE':
                return  {...state, loadedMore: true }
            case 'NEWS_FULL':
                return {...state, full: true}
            default:
                return state;
        }
    }

    states.buildingState = (state = {}, action) => {
        switch (action.type) {
            case 'BUILDING_SET':
                return {
                    ...state,
                    building_slugs: action.slugs
                };
            case 'BUILDING_CLEAR':
                return {
                    ...state,
                    building_slugs: null
                };
            default:
                return state;
        }
    }

    states.searchState = (state = {}, action) => {
        switch (action.type) {
            case 'SEARCH_VIEW_DEFAULT':
                return {...state, viewState: 0, result: []}
            case 'SEARCH_CHANGED':
                return {...state, searchString: action.search}
            case 'SEARCH_LOADING':
                return {...state, loading: true, result: [], viewState: 1}
            case 'SEARCH_LOADED':
                return {...state, loading: false, timer: null, result: action.result}
            default:
                return state;
        }
    }


    return states;
}
